function toParseableSVG(svg: string) {
  const container = document.createElement('div');
  container.innerHTML = svg;

  return container;
}

export default {
  toParseableSVG,
};
